import { GridSelectableMode } from '@progress/kendo-react-grid';

export interface selectionModesType {
  value: GridSelectableMode | undefined;
  label: string;
}

export const selectionModes: selectionModesType[] = [
  { value: 'single', label: 'Single selection mode' },
  { value: 'multiple', label: 'Multiple selection mode' },
];
